import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from "@angular/common";
import { LanguageEnum } from "../../enums";
import { TranslatePipe } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-language-selection",
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, TranslatePipe, MatIconModule],
  templateUrl: "./language-selection.component.html",
  standalone: true,
  styleUrl: "./language-selection.component.scss"
})
export class LanguageSelectionComponent {
  @Input() selectLangCode?: LanguageEnum = LanguageEnum.En;
  @Output() selecteLanguge = new EventEmitter<LanguageEnum>();

  protected isMenuOpened = true
  protected readonly languages = [
    { id: LanguageEnum.En, label: 'English', flag: 'https://cdn.weglot.com/flags/rectangle_mat/us.svg' },
    { id: LanguageEnum.Es, label: 'Espanol', flag: 'https://cdn.weglot.com/flags/rectangle_mat/es.svg' },
  ];

  selectedLanguage() {
    return this.languages.find(lang => lang.id === this.selectLangCode);
  }

  onOpenedChange(isOpened: boolean) {
    this.isMenuOpened = isOpened
  }

  onSelectLang(e: MatSelectChange) {
    this.selecteLanguge.emit(e.value)
  }
}